import { DATATABLE_EXPORT } from "../../../../Config/ApiUrl";
import * as actions from "../../../../Config/ApiUrl";

export const Schema = {
	components: { },

	data() {

		return {
			DATATABLE_EXPORT,
			isStudentListModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: "/transaction/getClassCurrentSemester",
			tableId: "continue-list-table",
			formId: "STUDENT-LIST-form",
			rowData: {},
			tableColumns: [
				{
					title: "Class Name",
					type: "custom-html",
					key: "course_name",
					modifier: (value, row) => {
						return `<a onclick="window.handleListStudent(${row.id},'${row.course_name}')"
									style="color: blue;cursor: pointer;">
									${value}
								</a>`;
					}
				},
				{
					title: "Day",
					type: "custom-html",
					key: "day",
					modifier: (value, row) => {
					
						const days = {
							1: "Monday",
							2: "Tuesday",
							3: "Wednesday",
							4: "Thursday",
							5: "Friday",
							6: "Saturday",
							7: "Sunday",
						};

						return days[row.day] || "-";
					},
				},
				{
					title: "Start Date",
					type: "text",
					key: "course_date_clc_start",
				},
				{
					title: "End Date",
					type: "text",
					key: "course_date_clc_end",
				},
				{
					title: "Note",
					type: "text",
					key: "note",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "ContinueListTable",
				url: "/transaction/getClassCurrentSemester",
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					// {
					// 	title: this.$t("edit"),
					// 	icon: "eye",
					// 	type: "none",
					// 	component: "app-add-modal",
					// 	modalId: "CONTINUELIST-form",
					// },
				],
				filters: [
					
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		isPifDisabled(rowData) {
			if (rowData.status === "inactive") return true;
			else if (rowData.status === "not_interested") return true;
			else if (rowData.status === "invalid") return true;
			else return false;
		},
	},
};
